import { orchestrator } from 'satcheljs';
import { connectedAccountDisconnected } from 'owa-accounts-service';
import setAccountsEditorState from '../mutators/setAccountsEditorState';
import { AccountsEditorState } from '../store/schema/AccountsEditorState';
// import { startAddingAccount } from '../actions/internalActions';
// import getSelectedAccountProvider from '../selectors/getSelectedAccountProvider';

orchestrator(connectedAccountDisconnected, ({ isReconnectFlow }) => {
    if (!isReconnectFlow) {
        setAccountsEditorState(AccountsEditorState.Removed);
    }
    // else {
    //     // for re-connect flow, trigger a add account now for the selected provider type
    //     // this will be removed once VSO 58686 is fixed, because then we will doing a remove after add (Rather then add after remove)
    //     startAddingAccount(getSelectedAccountProvider());
    // }
});
